import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import { LOGIN } from "../utils/mutations";
import Auth from "../utils/auth";
import { Link } from "react-router-dom";
import logo from "../assets/logo.svg"
import decode from "jwt-decode";
// import google from "../assets/google.svg"
import Swal from "sweetalert2";
import '../sharedStyles/devise.scss';

function Login(props) {
  const [remember, setRemember] = useState(false);
  const [variables, setVariables] = useState({ email: "", password: "", rememberMe: remember });
  const [loginUser, { error, loading }] = useMutation(LOGIN);

  const search = window.location.href;
  let queryParams = new URL(search);
  const plan = queryParams.searchParams.get('plan');

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const data = await loginUser({
        variables
      });
      const token = data.data.loginUser.token;
      const decodedToken = decode(token)
      decodedToken.sub === 1 ? (
        Swal.fire({
          padding: '1em',
          position: 'bottom-start',
          width: '400px',
          icon: 'error',
          text: "You are logging in as admin. Kindly create account or login as user.",
          timer: 2000,
          showConfirmButton: false,
          backdrop: false,
          background: '#ffffff',
          color: '#2a305d',
          iconColor: '#2a305d',
        })
      ) : (
        Auth.login(token)
      )
    } catch (e) {
      Swal.fire({
				padding: '1em',
				position: 'bottom-start',
				width: '400px',
				icon: 'error',
				text: e,
				timer: 2000,
				showConfirmButton: false,
				backdrop: false,
				background: '#ffffff',
				color: '#2a305d',
				iconColor: '#2a305d',
			})
    }
  };


  const handleChange = (event) => {
    const { name, value } = event.target;
    setVariables({
      ...variables,
      [name]: value,
    });
  };

  return (
    <div className="container-fluid px-0 bg-FCF8F2">
      <div className="row gx-0">
        <div className="col-12 col-lg-6 login-bg order-2 order-lg-1 d-none d-lg-block">
          <div className="login-overlay">
            <div className="d-flex align-items-end h-100">
              <h2 className="text-white p-3 p-lg-4 p-xxl-5">
                Hit your target GRE score as quickly as possible.
              </h2>
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 d-flex align-items-center justify-content-center order-1 order-lg-2 py-4 min-vh-100">
          <div className="w-380 px-3">
            <div className="text-align-center">
              <a href="https://stellargre.com/">
                <img src={logo} className="img-fluid" alt="Logo" width="350" />
              </a>
            </div>
            <h3 className="mt-4 mt-md-40 mt-xl-52 mb-3 mb-md-4 mb-xl-36">Welcome Back.</h3>
            {/* <Link to="/" className="btn btn-outline-primary d-block btn-lg">
              <img src={google} className="me-8" alt="Google" />
              Sign in with Google
            </Link>
            <div className="d-flex align-items-center justify-content-center py-16">
              <hr className="w-100" />
              <div className="font-sm text-gray-500 px-8 py-s4">OR</div>
              <hr className="w-100" />
            </div> */}
            <form onSubmit={handleFormSubmit}>
              {error && <div className="mb-2 text-danger">{error.message}</div>}
              <div className="mb-16">
                <label htmlFor="email" className="form-label">Email address</label>
                <input type="email" className="form-control" id="email" name="email" aria-describedby="emailHelp" required placeholder="Enter your email address" onChange={handleChange} />
              </div>
              <div className="mb-12">
                <label htmlFor="password" className="form-label">Password</label>
                <input type="password" minLength={6} className="form-control" name="password" id="password" placeholder="Enter a strong 8 digit password" onChange={handleChange} required />
              </div>
              <div className="d-flex align-items-center justify-content-between mb-4 mb-md-40 mb-xl-56">
                <div className="form-check">
                  <input type="checkbox" className="form-check-input" id="remember_me" onChange={()=>{setRemember(!remember)}} />
                  <label className="form-check-label mb-0" htmlFor="remember_me">Remember Me</label>
                </div>
                <Link to={`/forgot-password${plan ? `?plan=${plan}` : ''}`} className="fw-bold font-14 text-decoration-none">Forgot Password</Link>
              </div>
              <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center w-100 btn-lg" disabled={loading}>
                {
                  loading && 
                  <i className="fa-solid fa-spinner fa-spin font-20 me-8"></i>
                }
                Login
              </button>
              <div className="mt-36">
                <span className="text-gray-700">Not a member yet? </span>
                <Link to={`/signup${plan ? `?plan=${plan}` : ''}`} className="fw-semibold text-decoration-none">
                  Create Account
                </Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
